import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTheme } from '../context/ThemeContext';

const TooltipPortal = ({ children, show, buttonRef }) => {
  const { darkMode } = useTheme();
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    const updatePosition = () => {
      if (show && buttonRef.current) {
        const rect = buttonRef.current.getBoundingClientRect();
        const tooltipWidth = 320; // w-80 = 20rem = 320px

        // Calculate left position, ensure tooltip stays within viewport
        let left = rect.right + 8; // 8px offset to the right of the button
        if (left + tooltipWidth > window.innerWidth) {
          // If it would overflow right, position to the left of the button
          left = rect.left - tooltipWidth - 8;
        }
        if (left < 8) {
          left = 8; // Minimum 8px from left edge
        }

        setPosition({
          top: rect.top,
          left: left
        });
      }
    };

    updatePosition();

    // Update position on scroll or resize
    if (show) {
      window.addEventListener('scroll', updatePosition, true);
      window.addEventListener('resize', updatePosition);
      return () => {
        window.removeEventListener('scroll', updatePosition, true);
        window.removeEventListener('resize', updatePosition);
      };
    }
  }, [show, buttonRef]);

  if (!show) return null;

  return createPortal(
    <div
      className={`fixed z-[10000] w-80 p-4 text-sm rounded-lg shadow-2xl border-2 whitespace-normal pointer-events-none ${
        darkMode ? 'bg-slate-900 text-gray-200 border-teal-500' : 'bg-white text-stone-700 border-teal-600'
      }`}
      style={{
        top: `${position.top}px`,
        left: `${position.left}px`
      }}
    >
      {children}
    </div>,
    document.body
  );
};

export default TooltipPortal;
